import React from 'react';
import { useDispatch } from 'react-redux';
import JoditEditor from 'jodit-react';
import {
  editUserStoreProduct
} from 'redux/actions/products';


const config = {
  'showXPathInStatusbar': false,
  'spellcheck': false,
  'askBeforePasteHTML': false,
  'askBeforePasteFromWord': false,
  'disablePlugins': 'table,preview,table-keyboard-navigation,file,add-new-line,about,class-span,focus,delete,wrap-text-nodes,copy-format,clipboard,drag-and-drop,drag-and-drop-element,error-messages,format-block,fullsize,hotkeys,iframe,indent,hr,inline-popup,justify,limit,link,mobile,ordered-list,placeholder,redo-undo,resizer,search,select,size,resize-handler,stat,sticky,symbols,tooltip,xpath',
  'buttons': 'bold,italic,underline,strikethrough,fontsize,brush,ul,ol'
};

const Instructions = ({product}) => {
  const dispatch = useDispatch();
  const recommendedUses = product.custom_attributes?.find((a) => a.attribute_code === 'recommended_uses')?.value;

  const editProductInstruction = (newContent) => {
    const updatedProduct = {custom_attributes: product.custom_attributes.map((a) => a.attribute_code === 'recommended_uses' ? {...a, value: newContent} : a)};

    dispatch(editUserStoreProduct(updatedProduct));
  };

  return (
    <div className="w-full">
      <JoditEditor
        value={recommendedUses}
        config={config}
        onBlur={(newContent) => editProductInstruction(newContent)}
      />
    </div>
  );
};

export default Instructions;
